import { createSlice } from "@reduxjs/toolkit";

const WatchedVideoDetailsSlice = createSlice({
  name: "WatchedVideoDetails",

  initialState: {
    watchedVideoDetails: {},
    watchedDuration: 0,
    lastPaused: 0,
    totalWatchTime: 0,
    currentvideoTime: 0,
    noteAddedVideoTime: 0,
  },
  reducers: {
    setWatchedVideoDetails: (state, action) => {
      state.watchedVideoDetails = action.payload;
    },

    setTotalWatchTime: (state, action) => {
      state.totalWatchTime = action.payload;
    },

    setVideoLastPaused: (state, action) => {
      state.lastPaused = action.payload;
    },

    setNoteAddedVideoTime: (state, action) => {
      state.noteAddedVideoTime = action.payload;
    },

    setCurrentVideoTime: (state, action) => {
      state.currentvideoTime = action.payload;
    },
  },
});

export const {
  setWatchedVideoDetails,
  setTotalWatchTime,
  setVideoLastPaused,
  setCurrentVideoTime,
  setNoteAddedVideoTime,
} = WatchedVideoDetailsSlice.actions;
export default WatchedVideoDetailsSlice.reducer;
